import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';

import MenuIcon from '@material-ui/icons/Menu';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import NavBarStyle from '../../../styles/NavBarStyle';

import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';

const navBarStyle = NavBarStyle;

function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
};


function Header(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const matchTablet = useMediaQuery('(min-width:600px)');

    const navClasses = navBarStyle();
    const [height, setHeight] = React.useState(false);

    const [header, setHeader] = useState([]);

    useEffect(() => {
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/header`)
            .then((response) => {
                setHeader(response.data);
            })
            .catch((error) => {
            });
    }, []);

    const matchHome = props.location.pathname.toUpperCase() === '/home'.toUpperCase();
    const matchHome_2 = props.location.pathname.toUpperCase() === '/'.toUpperCase();
    const matchAboutUs = props.location.pathname.toUpperCase() === '/aboutUs'.toUpperCase();
    const matchOurWork = props.location.pathname.toUpperCase() === '/ourWork'.toUpperCase();
    const matchNews = props.location.pathname.toUpperCase() === '/news'.toUpperCase();
    const matchCareers = props.location.pathname.toUpperCase() === '/careers'.toUpperCase();
    const matchContact = props.location.pathname.toUpperCase() === '/contact'.toUpperCase();
    const matchAcademy = props.location.pathname.toUpperCase() === '/academy'.toUpperCase();

    const font = (background, fontWeight, color) => {
        var result = {
            backgroundColor: background,
            fontWeight: fontWeight,
            color: color,
        }
        return result;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRedirect = (params) => {
        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: params,
            },
        };
        history.push(from);
        setAnchorEl(null);
    };

    window.onscroll = function () { myFunction() };


    function myFunction() {
        var navbar = document.getElementById("toolbarD");
        var sticky = navbar.offsetTop;

        if (window.pageYOffset > sticky) {
            setHeight(true);
        } else {
            setHeight(false);
        }
    }

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            <HideOnScroll {...props}>
                <AppBar
                    elevation={!matchTablet ? 0 : 1}
                    position="absolute" // absolute
                    color={'inherit'}
                    className={navClasses.appBar}
                >

                    <Toolbar
                        className={navClasses.toolbar}
                        disableGutters
                        id={'toolbarD'}
                        style={height ? font('#000', '500', '#fff') : { backgroundColor: 'transparent' }}
                    >

                        <div className={navClasses.toolbarDiv}>
                            <Link to="/home">
                                {header.length === 0 || header.length === '' ? '' :
                                    matchHome || matchAboutUs || matchHome_2 || height ?
                                        <img
                                            src={replace(header.White_logo.url)}
                                            alt={header.White_logo.name}
                                        />
                                        :
                                        <img
                                            src={replace(header.logo[0].url)}
                                            alt={header.logo[0].name}
                                        />
                                }
                            </Link>
                        </div>
                        {matchTablet ?
                            <div className={navClasses.toolbarContainerOption}>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchAboutUs ? font('#fff', '500', '#000') : {}}
                                    to="/aboutUs"
                                >
                                    {'About Us'}
                                </Link>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchOurWork ? font('#000', '500', '#fff') : {}}
                                    to="/ourWork"
                                >
                                    {'Our Work'}
                                </Link>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchNews ? font('#000', '500', '#fff') : {}}
                                    to="/news"
                                >
                                    {'News'}
                                </Link>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchAcademy ? font('#000', '500', '#fff') : {}}
                                    to="/academy"
                                >
                                    {'Academy'}
                                </Link>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchCareers ? font('#000', '500', '#fff') : {}}
                                    to="/careers"
                                >
                                    {'Careers'}
                                </Link>
                                <Link
                                    className={matchHome || matchAboutUs || matchHome_2 || height ? navClasses.menuOption : navClasses.menuOptionBlack}
                                    style={matchContact ? font('#000', '500', '#fff') : {}}
                                    to="/contact"
                                >
                                    {'Contact'}
                                </Link>
                            </div>
                            :

                            <div >
                                {matchHome || matchAboutUs || matchHome_2 || height ?
                                    <MenuIcon className={navClasses.iconMenu} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick} />
                                    :
                                    <MenuIcon className={navClasses.iconMenuBlack} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick} />
                                }
                                <Menu
                                    id="fade-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={open}
                                    onClose={handleClose}
                                    TransitionComponent={Fade}
                                    disableScrollLock={true}
                                    classes={{
                                        paper: navClasses.menuMobilePaper,
                                        list: navClasses.menuMobileList
                                    }}
                                >
                                    <MenuIcon className={navClasses.iconMenuMobile} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClose} />
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/aboutUs')}>About Us</MenuItem>
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/ourWork')}>Our Work</MenuItem>
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/news')}>News</MenuItem>
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/academy')}>Academy</MenuItem>
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/careers')}>Careers</MenuItem>
                                    <MenuItem classes={{ root: navClasses.menuMobileItem }} onClick={() => handleRedirect('/contact')}>Contact</MenuItem>
                                </Menu>
                            </div>
                        }


                    </Toolbar>
                </AppBar>
            </HideOnScroll>
        </React.Fragment>
    );
}

export default withRouter(Header);